const Survey = require("~/types/Survey.js");
const events = require("./routeChangeEvents.js");
const mainViewNames = require("~/config.js").MainViewNames;

const routeChangeHandlers = {
    [events.ChangedToSurveyList.Name](prev, event) {
        const update = {
            MainViewName: mainViewNames.SurveyList,
            SurveyListSearchParameters: event.SearchParameters
        };

        const result = Object.assign({}, prev, update);

        return result;
    },
    [events.ChangedToSurvey.Name](prev, event) {
        let update = {
            MainViewName: mainViewNames.Survey,
            CurrentSurvey: Survey.FromViewChange(event, prev.CurrentSurvey)
        };

        const result = Object.assign({}, prev, update);

        return result;
    },
    [events.ChangedToSurveyConfirmation.Name](prev, event) {
        const update = {
            MainViewName: mainViewNames.SurveyConfirmation,
            CurrentSurvey: Survey.FromViewChange(event, prev.CurrentSurvey)
        };

        const result = Object.assign({}, prev, update);

        return result; 

    },
    [events.ChangedToSurveySummary.Name](prev, event) {
        const update = {
            MainViewName: mainViewNames.SurveySummary,
            CurrentSurvey: Survey.FromViewChange(event, prev.CurrentSurvey)
        };

        const result = Object.assign({}, prev, update);

        return result;
    },
    [events.ChangedToLegacySurvey.Name](prev, event) {
        const update = {
            MainViewName: mainViewNames.LegacySurvey,
            CurrentSurvey: Survey.FromViewChange(event, prev.CurrentSurvey)
        };

        const result = Object.assign({}, prev, update);

        return result;
    },
    [events.ChangedToImpersonation.Name](prev, event) {
        const update = {
            MainViewName: mainViewNames.Impersonation
        };

        const result = Object.assign({}, prev, update);

        return result;
    },
    [events.ChangedToReports.Name](prev, event) {
        const update = {
            MainViewName: mainViewNames.Reports
        };

        const result = Object.assign({}, prev, update);

        return result;
    },
    [events.ChangedToWalkThru.Name](prev, event) {
        const update = {
            MainViewName: mainViewNames.WalkThru,
            WalkThru: {
                SurveyID: event.SurveyID,
                SurveyType: event.SurveyType,
                SurveyFacilityNumber: event.FacilityNumber,
                IsLoading: false,
                LoadError: null,
                Data: null
            }
        };

        const result = Object.assign({}, prev, update);

        return result;
    }
};

module.exports = routeChangeHandlers;


// WEBPACK FOOTER //
// ./src/events/routeChange/routeChangeHandlers.js